// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DownloadPdfRequestModel from '../../model/download-pdf-request-model';
import DownloadPdfRequestDTO from '../dto/download-pdf-request-dto';
import dtoSchema from '../schemas/download-pdf-request-schema';

export default abstract class DownloadPdfRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DownloadPdfRequestDTO>) {
    super();
    if (data) {
      this.classTypeKey = data.classTypeKey ?? undefined;
    }
  }
  /**
  */
  classTypeKey?: string;

  static toModel(dto: DeepPartial<DownloadPdfRequestDTO>): DownloadPdfRequestModel;
  static toModel(dto: DeepPartial<DownloadPdfRequestDTO> | undefined | null): DownloadPdfRequestModel | undefined;
  static toModel(dto: DeepPartial<DownloadPdfRequestDTO> | undefined | null): DownloadPdfRequestModel | undefined {
    return dto ? new DownloadPdfRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DownloadPdfRequestModel> | DownloadPdfRequestModel): DownloadPdfRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      classTypeKey: unwrapped.classTypeKey,
    } as DownloadPdfRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DownloadPdfRequestModel, can not map to DownloadPdfRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
